import React, { useState, useEffect } from 'react';
import { InputGroup, TextArea, FileInput, Checkbox } from '@blueprintjs/core';
import {Translate, I18n} from 'react-redux-i18n';
import axios from 'axios';

import Loading from '../../components/Loading/Loading';
import style from './Scenarios.module.css';

export default function ContributeDialog({onClose, scenario}) {
    
    const [state, setState] = useState({
        title: "", selectedCategories: [], description: "", files: null, thumbnail: null, author: "", 
        categories: [], serviceAgreement: false
    })
    const [error, setError] = useState("")
    const [loading, setLoading] = useState(true)
    const [submitting, setSubmitting] = useState(false);
    const [thumbnailError, setThumbnailError] = useState(false);
    
    async function handleSubmit() {
        try {
            if(!state.title) {
                return setError("Title is missing")
            }
            if(state.title.length < 3) {
                return setError("Title must be at least 3 characters")
            }
            if(state.selectedCategories.length === 0) {
                return setError("No category selected")
            }
            if(!state.description) {
                return setError("Description is missing")
            }
            console.log("Submitted", {...state})
            setSubmitting(true)
            const data = new FormData()
            data.append("scenario", scenario)
            data.append("title", state.title)
            data.append("description", state.description)
            // data.append("author", state.author)
            data.append("categories", JSON.stringify(state.selectedCategories))
            // if(state.files) {
            //     console.log("FILE", state.files[0])
            //     data.append("file", state.files[0])
            // }
            if(state.thumbnail) {
                console.log("THUMBNAIL", state.thumbnail)
                data.append("thumbnail", state.thumbnail)
            }
            const response = await axios.post('/api/scenarios/contribute', data, {
                headers: {
                    'Authorization': window.localStorage.getItem("token")
                }
            })
            if(response.status < 400) {
                return onClose(true)
            }
            setError(response.data.error)
            setSubmitting(false)
        } catch (err) {
            console.error(err)
            setSubmitting(false)
        }
    }
    
    useEffect(()=>{
        console.log("Given scenario", scenario);
        const userData = JSON.parse(window.localStorage.getItem("user"))
        console.log("USER DATA", userData);
        setState((prevState)=>({...prevState, author: userData.name}));
        (async ()=>{
            try {
                const response = await axios.get('/api/category', {
                    headers: {
                        'Authorization': window.localStorage.getItem("token")
                    }
                })
                setState((prevState)=>({...prevState, categories: response.data.categories}));
            } catch (err) {
                console.error(err)
            } finally {
                setLoading(false);
            }
        })();
    }, [])
    
    return (
        loading?
        <Loading />
        :
        <div className="column" style={{padding: '20px 20px 0px 20px'}}>
                {
                    error?
                    <div className="row centered" style={{color: 'red', marginBottom: 8}}>
                        {error}
                    </div>
                    :
                    null
                }
            <InputGroup
                // leftElement={<Icon icon="tag" />}
                onChange={(event)=>{event.persist(); setState((prevState)=>({...prevState, title: event.target.value}))}}
                placeholder="Title"
                // value={state.title}
            />
            <TextArea
                // leftElement={<Icon icon="tag" />}
                onChange={(event)=>{event.persist(); setState((prevState)=>({...prevState, description: event.target.value}))}}
                placeholder="Description"
                value={state.description}
                style={{margin: '5px 0px'}}
            />
            <div style={{padding: '10px', display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
            {
                state.categories.filter((category)=>!category.parent).map((category)=>(
                    <div style={{width: '200px', marginBottom: 30}}>
                        <Checkbox 
                            key={category._id}
                            label={category.name} 
                            checked={state.selectedCategories.includes(category._id)} 
                            onChange={
                                (event)=>{
                                    event.persist();
                                    event.target.checked? 
                                    setState((prevState)=>({
                                        ...prevState,
                                        // to select parent cat as well: selectedCategories: prevState.selectedCategories.concat(category._id, ...prevState.categories.filter((cat)=>cat.parent === category._id).map((cat)=>cat._id))
                                        selectedCategories: prevState.selectedCategories.concat(category._id)
                                    })) 
                                    : 
                                     // to select parent cat as well: setState((prevState)=>({...prevState, selectedCategories: prevState.selectedCategories.filter((cat)=> cat !== category._id && prevState.categories.find((c)=>c._id === cat).parent !== category._id)}))
                                    setState((prevState)=>({...prevState, selectedCategories: prevState.selectedCategories.filter((cat)=> cat !== category._id)}))
                                }
                            }
                        />
                        <div style={{paddingLeft: '15px'}}>
                        {
                            state.categories
                            .filter((cat)=>cat.parent === category._id)
                            .map((cat)=>(
                                <Checkbox 
                                    key={cat._id}
                                    label={cat.name} 
                                    checked={state.selectedCategories.includes(cat._id)} 
                                    onChange={
                                        (event)=>{
                                            event.persist();
                                            event.target.checked? 
                                            setState((prevState)=>({...prevState, selectedCategories: prevState.selectedCategories.concat(cat._id, cat.parent)})) 
                                            : 
                                            setState((prevState)=>({...prevState, selectedCategories: prevState.selectedCategories.filter((word)=> word !== cat._id)})) 
                                        }
                                    }
                                />  
                            ))
                        }
                        </div>
                    </div>
                ))
            }
            </div>
            {/*
            <FileInput
                text={state.files && state.files.length? state.files[0].name : "Choose file..."}
                inputProps={{accept: '.zip,.tar,.tar.gz,.7z'}}
                buttonText={"Select"}
                onInputChange={(event)=>{event.persist(); console.log(event.target.files); setState((prevState)=>({...prevState, files: event.target.files}))}}
            />
            */}
            <FileInput
                text={state.thumbnail && state.thumbnail? state.thumbnail.name : "Choose thumbnail... (100 KBs Max)"}
                inputProps={{accept: 'image/*'}}
                buttonText={"Select"}
                onInputChange={(event)=>{
                    event.persist();
                    console.log(event.target.files);
                    if(event.target.files[0]?.size / 1024 > 100) {
                        return setThumbnailError(true);
                    }
                    setState((prevState)=>({...prevState, thumbnail: event.target.files[0]}))}
                }
            />
            {
                thumbnailError && <Translate style={{color: 'red'}} value="mutualAid.thumbnailSizeLimitExceeded"/>
            }
            <InputGroup
                // leftElement={<Icon icon="tag" />}
                // onChange={(event)=>{event.persist(); setState((prevState)=>({...prevState, author: event.target.value}))}}
                placeholder="Author"
                value={state.author}
                disabled={true}
                style={{marginBottom: 5}}
            />
            <Checkbox 
                label={<a href="https://simsushare.com/eula" target="_blank"><Translate value="mutualAid.agreeToTerms" /></a>} 
                checked={state.serviceAgreement} 
                onChange={
                    (event)=>{
                        event.persist();
                        setState((prevState)=>({...prevState, serviceAgreement: event.target.checked}))
                    }
                }
            />
            <button className={`btn btn-primary ${style.btn}`} style={{marginTop: 10}} onClick={handleSubmit} disabled={submitting || !state.serviceAgreement}>
              <i className="fas fa-fw fa-share-alt"/> <Translate value="scenarios.SubmitContribution"/>
            </button>
        </div>
    )
    
}